<div class="d-flex align-items-center">
  <input class="form-check-input mt-0 me-3" type="checkbox" attr.aria-label="{{ 'label.privacy-terms' | translate }}" id="gdprCheckbox" [formControl]="field">
  <label for="gdprCheckbox">
    <small>
      {{ 'label.confirmedGDPR-part-1' | translate }}
      <span (mousedown)="$event.stopPropagation()" (click)="preventClick($event)">
        <a (click)="openDialog('privacy-terms')" class="underline">
          {{ 'label.confirmedGDPR-part-2-link' | translate }}
        </a>
      </span
    >
      {{ 'label.confirmedGDPR-part-3' | translate }}
    </small>
  </label>
</div>

<div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
<div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
